<div
  class="mat-slide-toggle-wrapper"
  [class.inverted]="isInverted"
  [class.small]="isSmall"
  [class.with-border]="!!label"
  [class.has-errors]="ngControl && (ngControl.dirty || ngControl.touched) && ngControl.invalid"
>
  @if (label) {
    <div class="mat-slide-toggle-wrapper-label" [title]="label">
      @if (isBeta) {
        <i class="material-section-beta" [nimbusIcon]="icons.FLASK"> </i>
      }
      {{ label }}
    </div>
  }

  <div class="mat-slide-toggle-wrapper-suffix" (click)="onSuffixClick()">
    <ng-content></ng-content>
  </div>
  <mat-slide-toggle
    [aria-label]="ariaLabel || label"
    [disabled]="isDisabled"
    [(ngModel)]="value"
    (change)="onChange($event)"
    [class.toggle-checked]="value"
  ></mat-slide-toggle>
</div>

@if (ngControl && (ngControl.dirty || ngControl.touched) && ngControl.invalid && inputValidator.getErrorMessage(ngControl.errors)) {
  <mat-error>
    <i class="error-triangle" [nimbusIcon]="icons.EXCLAMATION_TRIANGLE"></i>
    <div>{{ inputValidator.getErrorMessage(ngControl.errors) }}</div>
  </mat-error>
}

@if (warningMessage) {
  <mat-hint align="start" [ngClass]="infoMessageStyle">
    @if (isOverlayWarningMessage) {
      <nimbus-mat-icon-overlay [icon]="messageIcon" [textTemplate]="text" [position]="overlayMessagePosition">
        <div class="overlay-warning-message-body">
          @if (overlayMessage.titleKey) {
            <div class="overlay-warning-message-header">
              @if (overlayMessage.icon) {
                <i [nimbusIcon]="overlayMessage.icon"></i>
              }
              <div class="block-title">{{ overlayMessage.titleKey | translate }}</div>
            </div>
          }
          <span [innerHtml]="overlayMessage.messageKey | translate"></span>
          @if (overlayMessage.additionalInfoKey) {
            <div class="overlay-additional-info">
              <span class="overlay-additional-info-bold">{{ overlayMessage.additionalInfoKey | translate }}</span>
            </div>
          }
          @if (overlayMessage.link && overlayMessage.linkTitleKey) {
            <div class="overlay-warning-message-footer">
              <a target="_blank" [href]="overlayMessage.link">{{ overlayMessage.linkTitleKey | translate }}</a>
            </div>
          }
        </div>
      </nimbus-mat-icon-overlay>
      <ng-template #text>
        <span class="hint-message overlay-hint-message" [ngClass]="{ 'hint-message-error': infoMessageStyle === 'error' }">
          <span class="hint-message-text">{{ isErrorMessage ? errorMessage : warningMessage }}</span>
          @if (warningMessageAdditionalInfo) {
            <span class="hint-message-additional-info" [ngClass]="{ 'hint-message-error': infoMessageStyle === 'error' }">
              {{ warningMessageAdditionalInfo }}
            </span>
          }
        </span>
      </ng-template>
    } @else {
      <div class="regular-warning-message-container">
        <i class="error-triangle" [nimbusIcon]="messageIcon"></i>
        <nimbus-tooltip [text]="warningMessage" [panelClass]="warningTooltipPanelClass"></nimbus-tooltip>
        <span class="hint-message-container">
          <span class="hint-message-text">{{ warningMessage }} </span>
          @if (warningMessageAdditionalInfo) {
            <span class="hint-message-additional-info spacer" [ngClass]="{ 'hint-message-error': infoMessageStyle === 'error' }">
              {{ warningMessageAdditionalInfo }}
            </span>
          }
        </span>
      </div>
    }
  </mat-hint>
}
